export default "__VITE_ASSET__77f4ca29__"